"use client";
import { ContextProviders } from "@contexts/index";
import React, { useEffect } from "react";

import Alerts from "../_components/Alerts";
import {
  AppBackgroundOverrides,
  AppWrapper,
  ContentArea,
  ContentWrapper,
  FontStyleOverrides,
  LayoutContainer,
  SuperNavContainer,
} from "./AppLayoutStyles";
import Themer from "../_components/Themer";
import Modal from "../_components/modal";
import Banner from "../_components/Banner";
import { TabletDown, TabletUp } from "@features/media-queries";
import MobileSuperNav from "@components/navigation/MobileSuperNav";
import SuperNav from "@components/navigation/SuperNav";
import useNavPoint from "@hooks/useNavPoint";
import useShowSuperNav from "@components/navigation/useShowSuperNav";
import useCurrentUser from "@actions/users/useCurrentUser";
import ProductsBetaBanner from "../_components/ProductsBetaBanner";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const navPoint = useNavPoint();
  const { user } = useCurrentUser();
  const showSuperNav = useShowSuperNav(navPoint, user);

  // Hide intercom by default in the app
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    window?.Intercom?.("update", { hide_default_launcher: true });
  }, []);

  return (
    <ContextProviders navPoint={navPoint}>
      <FontStyleOverrides />
      <AppBackgroundOverrides showSuperNav={showSuperNav} />
      <Alerts />
      <AppWrapper showSuperNav={showSuperNav}>
        <Banner />
        <LayoutContainer>
          {showSuperNav ? (
            <>
              <TabletUp>
                <SuperNavContainer>
                  <SuperNav />
                </SuperNavContainer>
              </TabletUp>
              <TabletDown>
                <MobileSuperNav />
              </TabletDown>
            </>
          ) : null}
          <ContentWrapper id="contentArea" showSuperNav={showSuperNav}>
            <ContentArea id="contentAreaInner">{children}</ContentArea>
            <ProductsBetaBanner navPoint={navPoint} />
          </ContentWrapper>
        </LayoutContainer>
        <Modal />
        <Themer />
      </AppWrapper>
    </ContextProviders>
  );
}
